/**
 * @param {string} nombre - Nombre de los campos qeu estan en el detalle (ejem acciones, secciones) para mostrar textos de inforamcion,(ejem no hay acciones).
 * @param {string} campoPrincipal - Nombre del campo principal aque contiene los detalles (ejem seccion o paquete).
 * @param {string} campoDetalle - Nombre del campo de los elementos dentro del detalle (ejemp accion,seccion).
 * @param {Array} data - Arreglo de datos a renderizar(trae la data compelta el elemto con sus detalles (ejem seccion con sus acciones)).
 * @param {Function} registrar - Función para agregar un nuevo detalle a un elemento (ejem agregar accion a seccion).
 * @param {Function} eliminar - Función para eliminar un detalle de un elemento (ejem eliminar accion de seccion).
 * @param {Function} editarPadre - Función para editar el elemento principal (editar nombre ejemp seccion o paquete).
 * @param {Function} eliminarPadre - Función para eliminar el elemento principal (eliminar seccion o paquete).
 */
import { useState } from "react"
import Button from "../common/Button"
import { FaTimes, FaFolder, FaEdit, FaTrash } from "react-icons/fa"

const ListaExpandible = ({
  nombre,
  campoPrincipal,
  campoDetalle,
  data,
  registrar,
  eliminar,
  editarPadre,
  eliminarPadre
}) => {
  const [openItem, setOpenItem] = useState(null)
  const toggleItem = (id) => {
    setOpenItem(openItem === id ? null : id)
  }

  // Verificar si 'data' es un arreglo
  const validData = Array.isArray(data) ? data : []

  return (
    <div className="py-2 px-4 space-y-2">
      {validData.map((item) => (
        <div key={item.id} className="border border-gray-300 rounded-lg shadow-sm transition-all hover:shadow-md">
          <div
              className={`flex justify-between items-center p-2 cursor-pointer transition-colors ${
                openItem === item.id ? "bg-[#3de8ff]" : "bg-gray-100 hover:bg-gray-200"
              }`}
              onClick={() => toggleItem(item.id)}
            >
            <div className="flex items-center gap-4">
              <h3 className="font-semibold text-gray-800">
                {item[campoPrincipal]} <span className="text-sm text-gray-500">({item.id})</span>
              </h3>
              <Button type="save" texto="&#10010;" onClick={(e) => registrar(e, item.id)} />
              <span className="text-gray-500">{item.descripcion}</span>
            </div>
            <div className="flex items-center gap-2">
              <Button      
                texto={<FaEdit />}
                onClick={(e) => editarPadre({e, id: item.id, titulo: item[campoPrincipal], descripcion: item.descripcion })} // Llamada a editarPadre
              />
              <Button
                type="delete"
                texto={<FaTrash className="text-white" />}
                onClick={(e) => eliminarPadre(e,item.id)} // Llamada a eliminarPadre
              />
              <svg
                className={`w-5 h-5 transform transition-transform ${openItem === item.id ? "rotate-180" : "rotate-0"}`}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
          </div>
          <div
            className={`overflow-hidden transition-all duration-200 ${openItem === item.id ? "max-h-96" : "max-h-0"}`}
          >
            <ul className="pl-6 py-2 space-y-1 bg-white border-t border-gray-200">
              {item[nombre].length === 0 ? (
                <li className="text-gray-500 text-sm italic">No hay {nombre} disponibles</li>
              ) : (
                item[nombre].map((dato, index) => (
                  <li
                    key={index}
                    className="text-gray-700 text-sm flex items-center justify-between gap-4"
                  >
                    <div className="flex items-center gap-2">
                      <Button
                        type="delete"
                        texto={<FaTimes />}
                        onClick={() => eliminar(dato.pivot.id)} // Eliminar detalle
                      />
                      <FaFolder className="text-blue-500" /> {/* Icono del ítem */}
                      {dato[campoDetalle]}
                      <span className="text-violet-500">{dato.descripcion}</span>
                    </div>
                  </li>
                ))
              )}
            </ul>
          </div>
        </div>
      ))}
    </div>
  )
}

export default ListaExpandible
